import ButtonBox from 'components/ButtonBox/ButtonBox';
import { css } from '@emotion/css';
import { Hymn } from 'hooks/useHymns';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { FavButton } from './FavButton';

export const HymnButton = ({ hymn }: { hymn: Hymn }) => {
    const location = useLocation();
    return (
        <Link
            className={css`
                cursor: ${'pointer'};
                user-select: none;
            `}
            to={`/hymns/${hymn.id}`}
            state={{ backLink: location.pathname }}
        >
            <ButtonBox>
                <div
                    className={css`
                        display: flex;
                        align-items: center;
                    `}
                >
                    <div
                        className={css`
                            flex-grow: 1;
                            flex-shrink: 1;
                        `}
                    >
                        <p>{hymn.title}</p>
                    </div>
                    <FavButton hymnId={hymn.id} />
                </div>
            </ButtonBox>
        </Link>
    );
};
